import { ProductsEnum, ProductsDataType } from '../@types/products';

const products: ProductsDataType = {
  [ProductsEnum.profit]: {
    title: { first: 'Calculator', second: 'Profit' },
    icon: 'calculator_profit_icon.png',
    desc: [
      'Calculează rapid și precis profitul net al societății tale, ținând cont de toate veniturile și cheltuielile înregistrate.',
      'Introdu datele financiare ale firmei și obține instant o imagine clară asupra rentabilității afacerii tale.',
      'Ideal pentru antreprenori care vor să monitorizeze evoluția profitului lunar sau anual, fără cunoștințe contabile avansate.',
    ],
  },
  [ProductsEnum.cashFlow]: {
    title: { first: 'Calculator', second: 'Cash Flow' },
    icon: 'calculator_cash_flow_icon.png',
    desc: [
      'Monitorizează fluxul de numerar al firmei tale în timp real și anticipează perioadele cu lichiditate scăzută.',
      'Analizează intrările și ieșirile de bani pentru a lua decizii financiare informate și a evita blocajele de cash.',
    ],
  },
  [ProductsEnum.register]: {
    title: { first: 'Registru', second: 'de casă' },
    icon: 'registru_de_casa_icon.png',
    desc: [
      'Gestionează registrul de casă al firmei tale digital, rapid și fără erori, în conformitate cu legislația română în vigoare.',
      'Înregistrează încasările și plățile în numerar, generează automat soldul zilnic și exportă documentele necesare contabilului tău.',
    ],
  },
  [ProductsEnum.dividends]: {
    title: { first: 'Formule', second: 'Dividende' },
    icon: 'formule_dividende_icon.png',
    desc: [
      'Calculează instant valoarea dividendelor nete cuvenite și a impozitului pe dividende datorat.',
      'Obține instant suma netă pe care o poți distribui, după aplicarea cotei de impozit pe dividende conform legislației fiscale române.',
    ],
  },
  [ProductsEnum.tva]: {
    title: { first: 'Formule', second: 'TVA' },
    icon: 'formule_tva_icon.png',
    desc: [
      'Calculează instant TVA-ul, fie că vrei să afli valoarea TVA, fie suma finală cu TVA inclus. Util pentru estimări rapide și verificări comerciale.',
      'Simplifică procesul de declarare a TVA și evită erorile de calcul care pot genera penalități din partea ANAF.',
    ],
  },
  [ProductsEnum.margin]: {
    title: { first: 'Calcul', second: 'Marja Profitului' },
    icon: 'formule_dividende_icon.png',
    desc: [
      'Calculează marja de profit net - indicatorul de măsurare a performanței unei afaceri, reprezintă profitul final după deducerea tuturor cheltuielilor, inclusiv taxe și dobânzi.',
      'Rezultatele marjelor variază considerabil în funcție de industrie, dar, în general, o marjă de profit net de 10% este considerată o marjă medie, o marjă de 20%, o marjă bună, iar o marjă de 5% este considerată o marjă mică.',
    ],
  },
  [ProductsEnum.generateStatement]: {
    title: { first: 'Generare', second: 'Declarație unică' },
    icon: 'generare_declaratie_unica_icon.png',
    desc: [
      'Generează automat Declarația Unică (D212) pentru impozitul pe venitul persoanelor fizice și contribuțiile sociale obligatorii.',
      'Completează datele necesare pas cu pas și descarcă declarația gata de depus la ANAF, economisind ore de muncă administrativă.',
    ],
  },
  [ProductsEnum.requests]: {
    title: { first: 'Solicitări', second: ' ' },
    icon: 'solicitari_icon.png',
    desc: [
      'Trimite solicitări către echipa Taxely Finance pentru consultanță financiară personalizată sau clarificări privind calculele efectuate.',
      'Echipa noastră de specialiști îți răspunde prompt și te ghidează în luarea celor mai bune decizii financiare pentru firma ta.',
    ],
  },
  [ProductsEnum.legacy]: {
    title: { first: 'Informații', second: 'Legislative' },
    icon: 'informatii_legislative_icon.png',
    desc: [
      'Accesează cele mai recente modificări legislative în domeniul fiscal și contabil, actualizate permanent de specialiștii noștri.',
      'Fii mereu la curent cu schimbările din Codul Fiscal, normele ANAF și reglementările care îți afectează direct afacerea.',
    ],
  },
};

export default products;